import React from "react";
import { liveSignals } from "../mock";

const PhoneCard = ({ image, points, highlighted }) => (
  <div
    className={`relative flex flex-col items-center transition-transform duration-500 hover:-translate-y-2 ${
      highlighted ? "md:-translate-y-4" : ""
    }`}
  >
    <div
      className={`relative rounded-[38px] p-1 ${
        highlighted
          ? "bg-gradient-to-b from-indigo-400/60 to-blue-600/30"
          : "bg-slate-800/40"
      }`}
    >
      <img
        src={image}
        alt="AI signal"
        className="h-[340px] w-auto object-contain drop-shadow-[0_20px_40px_rgba(30,64,175,0.4)]"
      />
    </div>
    <div className="mt-4 inline-flex items-center gap-1 rounded-full bg-emerald-500 px-5 py-1.5 text-sm font-bold text-white shadow-lg shadow-emerald-500/30">
      {points} <span>✅</span>
    </div>
  </div>
);

const LiveResults = () => {
  return (
    <section className="relative py-20 px-4">
      <div className="mx-auto max-w-6xl text-center">
        <p className="text-xs font-semibold tracking-[0.3em] text-sky-400 uppercase">
          Live Results
        </p>
        <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-extrabold text-white">
          Real Signals. Real Profits.
        </h2>
        <p className="mt-4 max-w-2xl mx-auto text-slate-400">
          Our clients share their wins daily — see the power of AI-precision
          trading.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10 items-end justify-items-center">
          {liveSignals.map((s) => (
            <PhoneCard key={s.id} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LiveResults;
